:host {
  height: inherit;
}
.person-selector{
  display: flex;
  align-items: center;
  padding: 4px;
}
.people-chips{
  width: 100%;
}
.person-chip {
  color: antiquewhite;
}

.search-results {
  width: 100%;
  background-color: var(--color-background-3);
}

.tag-group b {
  color: rgb(255, 153, 0);
}

.search-results-tag {
  cursor: pointer;
  color: antiquewhite;
  text-decoration: underline;
  padding-left: 20px;
}

.search-results-tag b {
  color: rgb(255, 153, 0);
}